import { jsx as _jsx } from "react/jsx-runtime";
import EditPathLengthFormik from './EditPathLengthFormik';
function SignalFormTab({ signalIndex }) {
    return _jsx(EditPathLengthFormik, { signalIndex: signalIndex });
}
export default SignalFormTab;
